import { IEnquiry } from '@simplyfly/shared';

import { getDisplayedEnquiryRefTitle } from './interfaces/enquiry.helpers';

export const preferLiteralEnquiryReferenceMatches = (
  enquiries: IEnquiry[],
  query: string
): IEnquiry[] => {
  const normalizedQuery = query.trim().toLocaleLowerCase();

  if (!normalizedQuery) {
    return enquiries;
  }

  const literalMatches = enquiries.filter(enquiry => {
    const references = [getDisplayedEnquiryRefTitle(enquiry, 'refEnquiry')];

    if (enquiry.refContractTitle || enquiry.refContractTitleDisplayed) {
      references.push(getDisplayedEnquiryRefTitle(enquiry, 'refContract'));
    }

    return references.some(reference =>
      reference.toLocaleLowerCase().startsWith(normalizedQuery)
    );
  });

  return literalMatches.length ? literalMatches : enquiries;
};
